import React, { useState, useEffect } from "react";
import ReactApexChart from 'react-apexcharts';
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";



const HEADER_HEIGHT = 56;

const Leadscoring = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  
  const getLabelInfo = (key) => {
    if (key === "visualizou") return { label: "Visualizou", points: 10 };
    if (key === "reproduziu") return { label: "Reproduziu", points: 40 };
    if (key === "reagiu") return { label: "Reagiu", points: 50 };
    return null;
  };

  const handleExport = (statusKey) => {
    // Exporta a somatória dos 3 labels por número (Visualizou, Reproduziu, Reagiu)
    const rows = generateCombinedTableData();
    if (!rows || rows.length === 0) {
      alert('Não há dados para exportar.');
      return;
    }

    const csvRows = [];
    csvRows.push(['Número', 'Visualizou', 'Reproduziu', 'Reagiu', 'Total']);
    for (const r of rows) {
      const num = `"${String(r.number).replace(/"/g, '""')}"`;
      const v = `"${String(r.visualizou)}"`;
      const rep = `"${String(r.reproduziu)}"`;
      const reg = `"${String(r.reagiu)}"`;
      const tot = `"${String(r.total)}"`;
      csvRows.push([num, v, rep, reg, tot]);
    }

    const csv = csvRows.map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'leadscoring_sum_export.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // Gráfico: granularidade e geração de dados de exemplo
  const [granularity, setGranularity] = useState('hour'); // 'hour' | 'day'
  const [visibleCount, setVisibleCount] = useState(10);

  useEffect(() => {
    setVisibleCount(10);
  }, [selectedStatus]);

  const generateSampleSeries = (statusKey, gran) => {
    // gera dados de exemplo — substitua por dados reais quando disponível
    const points = gran === 'hour' ? 24 : 14; // 24 horas ou 14 dias
    const base = statusKey === 'visualizou' ? 10 : statusKey === 'reproduziu' ? 40 : 50;
    const data = Array.from({ length: points }, (_, i) => Math.max(0, Math.round(base + (Math.random() * base * 0.6 - base * 0.3))));
    const categories = Array.from({ length: points }, (_, i) => {
      if (gran === 'hour') return `${i}:00`;
      const d = new Date(); d.setDate(d.getDate() - (points - 1 - i)); return `${d.getDate()}/${d.getMonth() + 1}`;
    });
    return { data, categories };
  };

  const generateSampleTableData = (statusKey) => {
    const base = statusKey === 'visualizou' ? 10 : statusKey === 'reproduziu' ? 40 : 50;
    const rows = Array.from({ length: 8 }, (_, i) => {
      const number = `+55 11 9${String(10000000 + i).slice(1)}`;
      const points = Math.max(0, Math.round(base + (Math.random() * base * 1.2 - base * 0.4)));
      return { number, points };
    });
    return rows;
  };

  const generateCombinedTableData = () => {
    const count = 30;
    const numbers = Array.from({ length: count }, (_, i) => `+55 11 9${(1000000 + i).toString().slice(1)}`);
    const rows = numbers.map((number, i) => {
      const visualizou = Math.max(0, Math.round(10 + Math.random() * 15 + (i % 5)));
      const reproduziu = Math.max(0, Math.round(40 + Math.random() * 50 - (i % 3)));
      const reagiu = Math.max(0, Math.round(50 + Math.random() * 60 - (i % 4)));
      const total = visualizou + reproduziu + reagiu;
      return { number, visualizou, reproduziu, reagiu, total };
    });
    return rows;
  };

  const chartOptionsFor = (statusKey) => {
    const info = getLabelInfo(statusKey) || { label: 'Todos', points: 0 };
    const seriesData = generateSampleSeries(statusKey || 'visualizou', granularity);
    return {
      series: [{ name: `${info.label} (${info.points})`, data: seriesData.data }],
      options: {
        chart: { id: 'leadscoring-chart', toolbar: { show: false }, zoom: { enabled: false } },
        colors: ['#005c53'],
        stroke: { curve: 'smooth', width: 3 },
        xaxis: { categories: seriesData.categories, labels: { rotate: -45 } },
        yaxis: { title: { text: 'Interações' } },
        grid: { borderColor: '#eef2f4' },
        dataLabels: { enabled: false },
        tooltip: { theme: 'light' },
      },
    };
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
              ? 220
              : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
              ? 220
              : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
              ? 220
              : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} />
            </a>
          ) : (
            <a href="/app">
              <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12, color: "#fff" }}>Dashboard</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanhas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Projetos" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi-robot" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Adicionarauto" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>


         <li className="w-100">
            <a
              href="/Blacklist"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-person-x" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Blacklist</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>


           <li className="w-100">
            <a
              href="/Webhook"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-link-45deg" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Webhook</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>

       <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-wifi" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Broadcasts</span>}
            </a>
          </li>
          
        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Leadscoring</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "6px 16px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
               <li>
                <a className="dropdown-item" href="/Editarperfil">Perfil</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Treinamentos</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Termos de uso</a>
              </li>

              <li>
                <a className="dropdown-item" href="/sign-in">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: windowWidth > 768 ? (sidebarOpen ? 220 : 70) : (sidebarOpen ? '80vw' : 56),
        paddingTop: HEADER_HEIGHT,
        width: windowWidth > 768
          ? (sidebarOpen ? "calc(100% - 220px)" : "calc(100% - 70px)")
          : (sidebarOpen ? "calc(100% - 80vw)" : "calc(100% - 56px)"),
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
        position: 'relative',
      }}>
        <div style={{ padding: 24, position: "relative" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
            <h2 style={{ margin: "0 0 12px 0", color: "#005c53" }}>Leadscoring</h2>
            <div>
              <button
                onClick={() => handleExport(selectedStatus)}
                style={{
                  background: "#005c53",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: 8,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                }}
                title="Exportar dados"
              >
                <i className="bi bi-download" style={{ fontSize: 16 }}></i>
                Exportar
              </button>
            </div>
          </div>
          <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginTop: 12 }}>
            <button
              onClick={() => setSelectedStatus("visualizou")}
              aria-pressed={selectedStatus === "visualizou"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                background: "#005c53",
                color: "#fff",
                border: "none",
                padding: "10px 14px",
                borderRadius: 8,
                cursor: "pointer",
                minWidth: 180,
              }}
            >
              <i className="bi bi-eye" style={{ fontSize: 18 }}></i>
              <div style={{ textAlign: "left" }}>
                <div style={{ fontWeight: "600" }}>Visualizou 10</div>
                <div style={{ fontSize: 12, opacity: 0.9 }}>10 pontos</div>
              </div>
            </button>

            <button
              onClick={() => setSelectedStatus("reproduziu")}
              aria-pressed={selectedStatus === "reproduziu"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                background: "#005c53",
                color: "#fff",
                border: "none",
                padding: "10px 14px",
                borderRadius: 8,
                cursor: "pointer",
                minWidth: 180,
              }}
            >
              <i className="bi bi-play-fill" style={{ fontSize: 18 }}></i>
              <div style={{ textAlign: "left" }}>
                <div style={{ fontWeight: "600" }}>Reproduziu 40</div>
                <div style={{ fontSize: 12, opacity: 0.9 }}>40 pontos</div>
              </div>
            </button>

            <button
              onClick={() => setSelectedStatus("reagiu")}
              aria-pressed={selectedStatus === "reagiu"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                background: "#005c53",
                color: "#fff",
                border: "none",
                padding: "10px 14px",
                borderRadius: 8,
                cursor: "pointer",
                minWidth: 180,
              }}
            >
              <i className="bi bi-heart-fill" style={{ fontSize: 18 }}></i>
              <div style={{ textAlign: "left" }}>
                <div style={{ fontWeight: "600" }}>Reagiu 50</div>
                <div style={{ fontSize: 12, opacity: 0.9 }}>50 pontos</div>
              </div>
            </button>
          </div>

          <div style={{ marginTop: 20 }}>
            {selectedStatus ? (
              <div style={{ background: "#ffffff", padding: 16, borderRadius: 8, boxShadow: "0 2px 6px rgba(0,0,0,0.06)" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                  <div style={{ fontWeight: 700 }}>{getLabelInfo(selectedStatus).label} — Interações</div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button
                      onClick={() => setGranularity('hour')}
                      style={{
                        padding: '6px 10px',
                        borderRadius: 6,
                        border: granularity === 'hour' ? '2px solid #00473f' : '1px solid #e6eef0',
                        background: granularity === 'hour' ? '#00473f' : '#fff',
                        color: granularity === 'hour' ? '#fff' : '#005c53',
                        cursor: 'pointer'
                      }}
                    >Por hora</button>
                    <button
                      onClick={() => setGranularity('day')}
                      style={{
                        padding: '6px 10px',
                        borderRadius: 6,
                        border: granularity === 'day' ? '2px solid #00473f' : '1px solid #e6eef0',
                        background: granularity === 'day' ? '#00473f' : '#fff',
                        color: granularity === 'day' ? '#fff' : '#005c53',
                        cursor: 'pointer'
                      }}
                    >Por dia</button>
                  </div>
                </div>
                <div style={{ width: '100%' }}>
                  {(() => {
                    const cfg = chartOptionsFor(selectedStatus);
                    return (
                      <ReactApexChart options={cfg.options} series={cfg.series} type="area" height={280} />
                    );
                  })()}
                </div>
                <div style={{ marginTop: 12 }}>
                  <div style={{ color: '#6b7280', marginBottom: 8 }}>Dados de exemplo. Integre sua API para exibir números reais.</div>
                  <div style={{ borderRadius: 8 }}>
                    {(() => {
                      const rows = generateSampleTableData(selectedStatus);
                      const isListView = rows.length > 10;
                      if (!isListView) {
                        return (
                          <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 420 }}>
                              <thead>
                                <tr>
                                  <th style={{ textAlign: 'left', padding: '10px 12px', background: '#005c53', color: '#fff' }}>Número</th>
                                  <th style={{ textAlign: 'right', padding: '10px 12px', background: '#005c53', color: '#fff' }}>Pontos</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.map((r, idx) => (
                                  <tr key={idx} style={{ background: idx % 2 === 0 ? '#fff' : '#fbfdfe' }}>
                                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #eef2f4' }}>{r.number}</td>
                                    <td style={{ padding: '10px 12px', borderBottom: '1px solid #eef2f4', textAlign: 'right', fontWeight: 600 }}>{r.points}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        );
                      }

                      // List view for many rows
                      const shown = rows.slice(0, visibleCount);
                      return (
                        <div>
                          <div style={{ maxHeight: 320, overflowY: 'auto', border: '1px solid #eef2f4', borderRadius: 8 }}>
                            {shown.map((r, idx) => (
                              <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', borderBottom: '1px solid #f1f6f7', background: idx % 2 === 0 ? '#fff' : '#fbfdfe' }}>
                                <div style={{ color: '#0b5960' }}>{r.number}</div>
                                <div style={{ fontWeight: 700, color: '#005c53' }}>{r.points}</div>
                              </div>
                            ))}
                          </div>
                          {rows.length > visibleCount && (
                            <div style={{ marginTop: 8, textAlign: 'center' }}>
                              <button
                                onClick={() => setVisibleCount((v) => Math.min(rows.length, v + 10))}
                                style={{ background: '#005c53', color: '#fff', border: 'none', padding: '8px 12px', borderRadius: 6, cursor: 'pointer' }}
                              >
                                Mostrar mais
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ color: "#6b7280" }}>Selecione um status para ver os dados relacionados.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leadscoring;